import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Card from '../../elements/common/Card';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';

import CustomRedirectsApi from 'Api/CRM/Modules/CustomRedirectsApi';
import CustomRedirect from 'Api/Models/CustomRedirect';

function SingleCustomRedirect() {
    const { id } = useNumberParams();
    const [customRedirect, setCustomRedirect] = useState<CustomRedirect>({} as CustomRedirect);

    useOnce(() => CustomRedirectsApi.getById(id).then(setCustomRedirect));

    return (
        <Card title="Custom redirect details">
            <TableDetailsBody>
                <Row label="ID">{customRedirect.id}</Row>
                <Row label="Source url">{customRedirect.source_url}</Row>
                <Row label="Target url">{customRedirect.target_url}</Row>
                <Row label="Status code">{customRedirect.status_code}</Row>
                <Row label="Updated at">{customRedirect.updated_at}</Row>
                <Row label="Created at">{customRedirect.created_at}</Row>
            </TableDetailsBody>
            <Link to={`/custom-redirects/${customRedirect.id}/edit`} className="btn btn-default">
                Edit custom redirect
            </Link>
        </Card>
    );
}

export default SingleCustomRedirect;
